<template>

  <div class="column col-10 col-mx-auto">




    <div class="wrap">

      <!-- blad przetwarzania wniosku (komunikat ustawiony przez DynamicForm na NauPage.pendingMessage) -->
      <template v-if="pendingMessage">
        <h3 class="entry-title">
          <i class="fas fa-exclamation-triangle warn"></i> Nie udało się przetworzyć Twojego wniosku.
        </h3>

        <p class="pending-message"><strong>{{ pendingMessage }}</strong></p>

        <p class="pending-message">
          W razie pytań prosimy o kontakt z infolinią <a href="tel:226967270"><strong>22 696 72 70</strong></a>.
        </p>
      </template>


      <!-- wniosek w trakcie przetwarzania -->
      <template v-else>
        <h3 class="entry-title">
          <i class="fas fa-hourglass-half"></i> Dziękujemy za Twoją cierpliwość, Twój wniosek jest w trakcie procesowania.
        </h3>


        <h3 class="entry-title">
           Niebawem się z Tobą skontaktujemy.
        </h3>
      </template>


      <div class="form-group form-btn-wrap column col-10 col-mx-auto">

        <a v-if="$root.mainpage && $root.mainpage.loggedIn" class="form-button btn btn-outline-primary btn-lg" @click="$router.push({path: '/client'})">Przejdź do strefy klienta</a>

      </div>


    </div>

  </div>

</template>

<script>



  export default {

    name: 'ZetosTimeoutPage',


    data() {

      return {

      }
    },


    computed: {

      // komunikat bledu ustawiony przez DynamicForm na root page (NauPage)
      pendingMessage() {

        return this.$root.mainpage ? this.$root.mainpage.pendingMessage : '';
      }
    },
  }
</script>

<style scoped>
  h3 i {
    color: #0bc268;
  }
  h3 i.warn {
    color: #d9822b;
  }
  .pending-message {
    font-size: 18px;
    text-align: center;
    margin: 0 auto 1em;
    max-width: 640px;
  }
  .form-button {
    color: #00605c;
    border-color: #00605c;
  }
  .fa-hourglass-half{
    margin-right:5px;
  }

  .entry-title {
    font-size: 32px;
    margin-block-end: 30px;
    text-align: center;
  }


  .form-btn-wrap {
    margin-top: .5rem;
    padding: 2rem 1rem;
    display: flex;
    justify-content: center;
  }

  .button {
    cursor: pointer;
    min-width: 260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;
    border-radius: 10px;
    border: 0px;
    margin: 0 .5rem;
  }

    .button.btn-prev {
      background-color: #dfdfdf;
      color: rgb(64, 64, 64);
    }

      .button.btn-prev:hover {
        box-shadow: inset -400px 0 0 0 #bebebe;
      }



  .wrap {
    position: relative;
    padding-top: 1rem;
    margin: 2rem 0;
  }

    .wrap::before {
      content: "";
      position: absolute;
      top: 0;
      left: -5em;
      right: 0;
      bottom: 0;
      display: block;
      background-color: #f7f7f7;
      border-radius: 0 90px 90px 0;
      -webkit-transform: skew(-17deg,0deg);
      transform: skew(-7deg,0deg);
      z-index: -2;
    }

    .wrap::after {
      content: "";
      position: absolute;
      top: 0;
      right: 50%;
      left: -100vw;
      bottom: 0;
      display: block;
      background-color: #f7f7f7;
      z-index: -2;
    }

  
</style>



// WEBPACK FOOTER //
// src/ZetosTimeoutPage.vue